import { render, staticRenderFns } from "./_cancelledBetList.vue?vue&type=template&id=db6989f4&scoped=true&lang=pug&"
import script from "./_cancelledBetList.vue?vue&type=script&lang=js&"
export * from "./_cancelledBetList.vue?vue&type=script&lang=js&"
import style0 from "./_cancelledBetList.vue?vue&type=style&index=0&id=db6989f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6989f4",
  null
  
)

export default component.exports